/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */

import Automation from 'routes/automation.js';
import CoreRoutes from 'routes/core.js';
import InvoicingRoutes from 'routes/invoicing.js';
import ThirdRoutes from 'routes/third.js';
import BankReconciliationRoutes from 'routes/bankreconciliation.js';
import CRMRoutes from 'routes/crm.js';
import ActivityRoutes from 'routes/activity.js';
import ProspectionRoutes from 'routes/prospection.js';
import ApiRoutes from 'routes/api.js';
import AgendaRoutes from 'routes/agenda.js';
import StatisticsRoutes from 'routes/statistics.js';
import OcrRoutes from 'routes/ocr.js';
import AccountingRoutes from 'routes/accounting.js';
import ErrorsRoutes from 'routes/errors.js';
import ItemsRoutes from 'routes/items.js';
import SettingsRoutes from 'routes/settings.js';
import AnnotationRoutes from 'routes/annotation.js';
import PurchaseRoutes from 'routes/purchase.js';
import MassmaillingRoutes from 'routes/massmailling.js';
import ProposalRoutes from 'routes/proposal.js';
import OnboardingRoutes from 'routes/onboarding.js';
import WebhooksRoutes from 'routes/webhooks.js';
import PopinRoutes from 'routes/popin.js';
import StaffRoutes from 'routes/staff.js';
import SAMRoutes from 'routes/sellsyaccountmanager.js';
import Scheduler from 'routes/scheduler.js';
import Reports from 'routes/reports.js';
import Compass2 from 'routes/compass2.js';
import Objectives from 'routes/objectives.js';
import Emails from 'routes/emails.js';
import Marketing from 'routes/marketing.js';
import CommonComponents from 'routes/commonComponents.js';
import Recap from 'routes/recap.js';
import Playground from 'routes/playground';
import Pdp from 'routes/pdp.js';

export default [
    ...Automation,
    ...CoreRoutes,
    ...InvoicingRoutes,
    ...ThirdRoutes,
    ...BankReconciliationRoutes,
    ...CRMRoutes,
    ...ActivityRoutes,
    ...ProspectionRoutes,
    ...ApiRoutes,
    ...AgendaRoutes,
    ...StatisticsRoutes,
    ...OcrRoutes,
    ...AccountingRoutes,
    ...ErrorsRoutes,
    ...ItemsRoutes,
    ...SettingsRoutes,
    ...AnnotationRoutes,
    ...PurchaseRoutes,
    ...MassmaillingRoutes,
    ...ProposalRoutes,
    ...OnboardingRoutes,
    ...WebhooksRoutes,
    ...PopinRoutes,
    ...StaffRoutes,
    ...SAMRoutes,
    ...Scheduler,
    ...Reports,
    ...Compass2,
    ...Objectives,
    ...Emails,
    ...Marketing,
    ...Recap,
    ...CommonComponents,
    ...Playground,
    ...Pdp,
];
